const ADMIN_CUSTOM_PROFILE_CHANNEL = "line";
const ADMIN_CUSTOM_PROFILE_DEFAULT_IMAGE =
  "../public/img/default_profile_img.png";
const ADMIN_CUSTOM_PROFILE_LINE_DISABLED_IMAGE =
  "../public/img/line-disable.png";
const ADMIN_CUSTOM_PROFILE_META = {
  line: {
    label: "LINE",
    accent: "#06C755",
    previewFrom: "OA name",
  },
};
const ADMIN_CUSTOM_PROFILE_ALLOWED_IMAGE_TYPES = {
  "image/png": true,
  "image/jpeg": true,
  "image/jpg": true,
};

function getAdminCustomProfileMessage(error) {
  return (
    _.get(error, ["data", "msg"]) ||
    _.get(error, ["msg"]) ||
    _.get(error, ["statusText"]) ||
    _.get(error, ["message"]) ||
    ""
  );
}

function isAdminCustomProfileSupportedImageFile(file) {
  if (!file) {
    return false;
  }

  const fileType = (file.type || "").toLowerCase();
  const fileName = (file.name || "").toLowerCase();

  if (ADMIN_CUSTOM_PROFILE_ALLOWED_IMAGE_TYPES[fileType]) {
    return true;
  }

  return /\.(png|jpe?g)$/.test(fileName);
}

function getAdminCustomProfileProfileId(item, currentUser) {
  return (
    _.get(item, "profile_id") ||
    _.get(item, "profileId") ||
    _.get(item, "user_profile_id") ||
    (_.get(item, "username") === _.get(currentUser, "email")
      ? _.get(currentUser, "profile_id")
      : "") ||
    ""
  );
}

function getAdminCustomProfileNexusUserId(item, currentUser) {
  return (
    _.get(item, "nexus_user_id") ||
    (_.get(item, "username") === _.get(currentUser, "email")
      ? _.get(currentUser, "nexus_user_id")
      : "") ||
    ""
  );
}

function getAdminCustomProfileMatchKey(item, currentUser) {
  return getAdminCustomProfileNexusUserId(item, currentUser);
}

function getAdminCustomProfileSelfKey(currentUser) {
  return (
    "self:" +
    (_.get(currentUser, "nexus_user_id") ||
      _.get(currentUser, "email") ||
      _.get(currentUser, "username") ||
      _.get(currentUser, "profile_id") ||
      "unknown")
  );
}

function buildAdminCustomProfileNexusUserData(user) {
  const displayName =
    _.get(user, "displayname") || _.get(user, "display_name") || "";
  const username = _.get(user, "username") || _.get(user, "email") || "";
  const email = _.get(user, "email") || _.get(user, "username") || "";
  const photo = _.get(user, "photo") || _.get(user, "img_profile") || "";

  return {
    nexus_user_id: _.get(user, "nexus_user_id") || "",
    displayname: displayName,
    display_name: displayName,
    username: username,
    email: email,
    img_profile: photo,
    photo: photo,
  };
}

function canUseAdminCustomProfileFallback(user) {
  const nexusUserData = buildAdminCustomProfileNexusUserData(user);

  return !!(
    nexusUserData.nexus_user_id &&
    (nexusUserData.displayname || nexusUserData.display_name) &&
    (nexusUserData.username || nexusUserData.email)
  );
}

function getAdminCustomProfileItem(customProfiles, channelType) {
  return (
    _.find(customProfiles, { channel_type: channelType }) ||
    _.first(customProfiles) ||
    {}
  );
}

function buildAdminCustomProfileRows(
  directoryInfo,
  currentUser,
  customProfileItems,
) {
  const rows = [];
  const seenNexusUserIds = {};
  const seenRowKeys = {};
  const groupedCustomProfiles = _.groupBy(customProfileItems, function (item) {
    return getAdminCustomProfileMatchKey(item, currentUser);
  });
  const currentUserMatchKey = getAdminCustomProfileMatchKey(
    currentUser,
    currentUser,
  );
  const currentUserRowKey = getAdminCustomProfileSelfKey(currentUser);

  _.forEach(directoryInfo, function (item) {
    const nexusUserId = getAdminCustomProfileNexusUserId(item, currentUser);
    const profileId = getAdminCustomProfileProfileId(item, currentUser);
    const itemEmail = _.get(item, "username") || _.get(item, "email") || "";
    const currentEmail = _.get(currentUser, "email") || _.get(currentUser, "username") || "";
    const isCurrentUserRow = nexusUserId === currentUserMatchKey ||
      (!currentUserMatchKey && itemEmail && currentEmail && itemEmail === currentEmail);
    const customProfiles = groupedCustomProfiles[nexusUserId] || [];
    const resolvedProfileId =
      profileId || _.get(customProfiles, [0, "profile_id"]) || "";
    const fallbackUser = isCurrentUserRow
      ? _.assign({}, currentUser, {
          nexus_user_id: currentUser.nexus_user_id || _.get(item, "nexus_user_id") || "",
        })
      : item;
    const row = {
      row_key:
        (isCurrentUserRow ? currentUserRowKey : nexusUserId) ||
        resolvedProfileId ||
        _.get(item, "username") ||
        _.get(item, "email") ||
        "",
      nexus_user_id:
        nexusUserId || _.get(customProfiles, [0, "nexus_user_id"]) || "",
      profile_id: resolvedProfileId,
      displayname:
        _.get(item, "displayname") ||
        _.get(item, "name") ||
        _.get(item, "username") ||
        _.get(item, "email") ||
        "-",
      email: _.get(item, "username") || _.get(item, "email") || "",
      img_profile:
        _.get(item, "img_profile") ||
        _.get(item, "avatar") ||
        ADMIN_CUSTOM_PROFILE_DEFAULT_IMAGE,
      custom_profiles: customProfiles,
      nexusUserData: canUseAdminCustomProfileFallback(fallbackUser)
        ? buildAdminCustomProfileNexusUserData(fallbackUser)
        : null,
    };

    if (!row.row_key || seenRowKeys[row.row_key]) {
      return;
    }

    seenRowKeys[row.row_key] = true;

    if (row.nexus_user_id) {
      seenNexusUserIds[row.nexus_user_id] = true;
    }

    rows.push(row);
  });
  const currentUserProfiles = groupedCustomProfiles[currentUserMatchKey] || [];
  const resolvedCurrentUserProfileId =
    _.get(currentUser, "profile_id") ||
    _.get(currentUserProfiles, [0, "profile_id"]) ||
    "";

  if (
    !seenRowKeys[currentUserRowKey] &&
    (!currentUserMatchKey || !seenNexusUserIds[currentUserMatchKey])
  ) {
    rows.unshift({
      row_key: currentUserRowKey,
      nexus_user_id: currentUserMatchKey,
      profile_id: resolvedCurrentUserProfileId,
      displayname:
        _.get(currentUser, "displayname") || _.get(currentUser, "email") || "-",
      email: _.get(currentUser, "email") || "",
      img_profile:
        _.get(currentUser, "img_profile") || ADMIN_CUSTOM_PROFILE_DEFAULT_IMAGE,
      custom_profiles: currentUserProfiles,
      nexusUserData: canUseAdminCustomProfileFallback(currentUser)
        ? buildAdminCustomProfileNexusUserData(currentUser)
        : null,
    });
  }

  return rows;
}

function createAdminCustomProfileDraft(row) {
  const channelType = ADMIN_CUSTOM_PROFILE_CHANNEL;
  const profile = getAdminCustomProfileItem(row.custom_profiles, channelType);
  const previewUrl = _.get(profile, "preview_url") || "";
  const mode = _.get(profile, "custom_admin_name_mode") || "default";
  const initialChannels = {};
  const channels = {};
  const channelState = {
    channel_type: channelType,
    display_name: _.get(profile, "display_name") || "",
    image_path: _.get(profile, "image_path") || "",
    preview_url: previewUrl,
    initial_preview_url: previewUrl,
    pending_image_data: "",
    dirty: false,
    errors: {},
    save_error: "",
  };

  initialChannels[channelType] = {
    display_name: channelState.display_name,
    image_path: channelState.image_path,
  };
  channels[channelType] = channelState;

  return {
    row_key: row.row_key,
    nexus_user_id:
      row.nexus_user_id ||
      _.get(profile, "nexus_user_id") ||
      _.get(row.nexusUserData, "nexus_user_id") ||
      "",
    profile_id: row.profile_id || _.get(profile, "profile_id") || "",
    displayname: row.displayname,
    email: row.email,
    avatar_url: row.img_profile || ADMIN_CUSTOM_PROFILE_DEFAULT_IMAGE,
    nexusUserData: row.nexusUserData || null,
    initialChannels: initialChannels,
    channels: channels,
    fieldErrors: {},
    mode: mode,
    initialMode: mode,
  };
}

function getEmptyAdminCustomProfileChannelState(channelType) {
  return {
    channel_type: channelType,
    display_name: "",
    image_path: "",
    preview_url: "",
    initial_preview_url: "",
    pending_image_data: "",
    dirty: false,
    errors: {},
    save_error: "",
  };
}

function preloadAdminCustomProfileImage(imageUrl) {
  if (!imageUrl || typeof Image === "undefined") {
    return Promise.resolve(imageUrl);
  }

  return new Promise(function (resolve) {
    const preloadedImage = new Image();
    preloadedImage.onload = function () {
      resolve(imageUrl);
    };
    preloadedImage.onerror = function () {
      resolve(imageUrl);
    };
    preloadedImage.src = imageUrl;
  });
}

function hasRequiredDisplayName(channelState) {
  return !!((_.get(channelState, "display_name") || "").trim());
}

// === Cropper utilities ===
const ADMIN_CUSTOM_PROFILE_LINE_IMAGE_TARGET_SIZES = [512, 448, 384, 320, 256, 192, 128];
const ADMIN_CUSTOM_PROFILE_LINE_IMAGE_MAX_BYTES = 1024 * 1024;

function createAdminCustomProfileCropperImage(src) {
  return new Promise(function (resolve, reject) {
    const image = document.createElement("img");

    image.onload = function () {
      resolve(image);
    };

    image.onerror = reject;
    image.src = src;
  });
}

function getAdminCustomProfileDataUrlSizeInBytes(dataUrl) {
  const base64Data = (dataUrl.split(",")[1] || "").replace(/\s/g, "");
  const padding = (base64Data.match(/=*$/) || [""])[0].length;

  return Math.max(Math.floor((base64Data.length * 3) / 4) - padding, 0);
}

function renderAdminCustomProfileCroppedPng(
  image,
  effectiveCropAreaPixels,
  targetSize,
) {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  canvas.width = targetSize;
  canvas.height = targetSize;

  context.drawImage(
    image,
    effectiveCropAreaPixels.x,
    effectiveCropAreaPixels.y,
    effectiveCropAreaPixels.width,
    effectiveCropAreaPixels.height,
    0,
    0,
    targetSize,
    targetSize,
  );

  return canvas.toDataURL("image/png");
}

function getAdminCustomProfileCroppedImage(src, cropAreaPixels) {
  return createAdminCustomProfileCropperImage(src).then(function (image) {
    const cropSize = Math.min(image.naturalWidth, image.naturalHeight);
    const effectiveCropAreaPixels = cropAreaPixels || {
      x: Math.max(Math.floor((image.naturalWidth - cropSize) / 2), 0),
      y: Math.max(Math.floor((image.naturalHeight - cropSize) / 2), 0),
      width: cropSize,
      height: cropSize,
    };
    let croppedImage = "";
    let targetSize = ADMIN_CUSTOM_PROFILE_LINE_IMAGE_TARGET_SIZES[0];
    let imageSizeInBytes = 0;

    ADMIN_CUSTOM_PROFILE_LINE_IMAGE_TARGET_SIZES.some(function (nextTargetSize) {
      targetSize = nextTargetSize;
      croppedImage = renderAdminCustomProfileCroppedPng(
        image,
        effectiveCropAreaPixels,
        targetSize,
      );
      imageSizeInBytes = getAdminCustomProfileDataUrlSizeInBytes(croppedImage);

      return imageSizeInBytes <= ADMIN_CUSTOM_PROFILE_LINE_IMAGE_MAX_BYTES;
    });

    return croppedImage;
  });
}
